import httpFetch from 'nodeify-fetch'

export default httpFetch
